/* =========================================================================
   Assembles the full app DOM (phone frame → screen → content → all screens +
   overlays + splash) as one HTML string. Structure/IDs/classes are preserved
   verbatim from the prototype so the lifted CSS applies unchanged.
   ========================================================================= */
import { welcomeHTML } from './welcome';
import { loginHTML } from './login';
import { registerHTML } from './register';
import { historyHTML } from './history';
import { homeHTML } from './home';
import { prerollHTML } from './preroll';
import { playHTML } from './play';
import { roundIntroHTML } from './roundIntro';
import { nextRoundHTML } from './nextRound';
import { resultsHTML } from './results';
import { bonusScreenHTML } from '../minigames/wheel';
import { mannaScreenHTML } from '../minigames/manna';
import { match3ScreenHTML } from '../minigames/match3';
import { maryScreenHTML } from '../minigames/maryMatch3';
import { overlaysHTML } from '../overlays';
import { candlePrayerHTML } from '../candlePrayer';
import { accountMenuHTML } from '../accountMenu';
import { homeFabHTML } from '../homeFab';
import { charactersOverlayHTML } from '../characters/ui';
import { tutorialOverlayHTML } from '../tutorialOverlay';
import { feastHTML } from './feast';
import { collectionsHTML } from './collections';
import { pilgrimageHTML } from './pilgrimage';
import { monasteryHTML } from './monastery';
import { leaderboardHTML } from './leaderboard';
import { friendlyHTML } from './friendly';

const bankbarHTML = /* html */ `
<div id="bankbar" class="bankbar hidden">
  <div class="brand">✝ <b>Catholics.app</b> Trivia</div>
  <div id="bankPill" class="bank-pill">
    <span class="dot"></span>
    <span class="amt money" id="bankVal">$0</span>
    <span id="floatDelta" class="float-delta"></span>
  </div>
</div>`;

const splashHTML = /* html */ `
<div id="screenSplash" class="splash">
  <video id="splashVideo" class="splash-video" playsinline muted autoplay preload="auto">
    <source src="intro.mp4" type="video/mp4" />
  </video>
  <div class="splash-skip" id="splashSkip">Tap to skip</div>
</div>`;

export const appShellHTML = /* html */ `
<div class="phone">
  <div class="screen">
    <div class="vignette" aria-hidden="true"></div>
    <div class="content">
      ${bankbarHTML}
      ${welcomeHTML}
      ${loginHTML}
      ${registerHTML}
      ${historyHTML}
      ${homeHTML}
      ${prerollHTML}
      ${playHTML}
      ${roundIntroHTML}
      ${nextRoundHTML}
      ${bonusScreenHTML}
      ${mannaScreenHTML}
      ${match3ScreenHTML}
      ${maryScreenHTML}
      ${resultsHTML}
      ${feastHTML}
      ${collectionsHTML}
      ${pilgrimageHTML}
      ${monasteryHTML}
      ${leaderboardHTML}
      ${friendlyHTML}
    </div>
    ${accountMenuHTML}
    ${homeFabHTML}
    ${overlaysHTML}
    ${candlePrayerHTML}
    ${charactersOverlayHTML}
    ${tutorialOverlayHTML}
    ${splashHTML}
  </div>
</div>`;
